/**
 * Same screen width breakpoints as Tailwind. 
 * See: https://tailwindcss.com/docs/screens and https://tailwindcss.com/docs/responsive-design
 * 
 * As Tailwind puts it, "Don't use `sm:` to target mobile devices"
 */
export enum ScreenBreakpoint {
    Mobile = 0,
    Small = 640,
    Medium = 768,
    Large = 1024,
    XLarge = 1280,
    XXLarge = 1536
}

export function getScreenBreakpoint(): ScreenBreakpoint {
    // Want to use innerWidth for desktop and screen.width for mobile
    var width = Math.min(window.screen.width, window.innerWidth);

    if (width > ScreenBreakpoint.XXLarge) {
        return ScreenBreakpoint.XXLarge;
    } else if (width > ScreenBreakpoint.XLarge) {
        return ScreenBreakpoint.XLarge;
    } else if (width > ScreenBreakpoint.Large) {
        return ScreenBreakpoint.Large;
    } else if (width > ScreenBreakpoint.Medium) {
        return ScreenBreakpoint.Medium;
    } else if (width > ScreenBreakpoint.Small) {
        return ScreenBreakpoint.Small;
    } else {
        return ScreenBreakpoint.Mobile;
    }
}

export function isMobileScreen(): boolean {
    return (window.screen.width < ScreenBreakpoint.Small);
}